document.addEventListener("DOMContentLoaded", function () {
  const copyBtns = document.querySelectorAll(".countdown-pro-code-btn");
  copyBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      var code = btn.previousElementSibling.textContent;
      const copied = btn.nextElementSibling;
      navigator.clipboard.writeText(code);
      btn.classList.add("active");

      setTimeout(function () {
        btn.classList.remove("active");
      }, 3000);
    });
  });

  const notifyBtns = document.querySelectorAll(".notify-btn");
  const klaviyoWindow = document.querySelector(".klaviyo-window-box");
  const closeBtn = document.querySelector(".close-window-btn");

  notifyBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      klaviyoWindow.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", () => {
    klaviyoWindow.classList.remove("active");
  });
});
